import type { FilterDataObject, FilterOptionDataObject, RequestFiltersByStatusRequestData } from '@/api/kubik/monolith'
import { messages } from '@/pages/Profiles/UserProfile/components/Sales/messages'
import type { TOrderType } from '@/types/HarvestSaleLots'
import { ESaleRequestFilterParams } from '@/types/Profile/SaleRequestFilter/ESaleRequestFilterParams'
import type { TSalesOptions } from './interfaces'

export const getSalesFilterDropdownOptions = (cultureFilters: FilterDataObject): TSalesOptions => {
  return (
    cultureFilters?.options?.map((el: FilterOptionDataObject) => ({
      label: el?.name || '',
      value: el?.value as unknown as string,
    })) || []
  )
}

export const sortSaleRequestFilters = (filters?: FilterDataObject[], initialValue = {}): Record<string, TSalesOptions> => {
  if (!filters) return initialValue

  return filters.reduce((groupedFilters, filter) => {
    if (!filter.value) return groupedFilters

    return {
      ...groupedFilters,
      [filter.value]: getSalesFilterDropdownOptions(filter),
    }
  }, initialValue)
}

export const getSuggestionValue = (value: { name: string }) => value.name

export const transformValueToSortFormState = (value: RequestFiltersByStatusRequestData) => {
  const keys = Object.keys(value) as (keyof RequestFiltersByStatusRequestData)[]

  return keys.reduce((acc: Record<string, string | undefined>, key: keyof RequestFiltersByStatusRequestData) => {
    const currentFilterValue = value[key]

    if (typeof currentFilterValue === 'string') {
      return { ...acc, [key]: currentFilterValue }
    }

    if (Array.isArray(currentFilterValue) && currentFilterValue.length > 0) {
      return { ...acc, [key]: currentFilterValue.join(',') }
    }

    return acc
  }, {})
}

export function parseSearchParamsToRequestBody(searchParams: URLSearchParams): {
  requestBody: RequestFiltersByStatusRequestData
  additionalParams: Record<string, string[] | string>
} {
  const requestBody: RequestFiltersByStatusRequestData = {
    cultures: [],
    regionCodes: [],
    statuses: [],
    agrarians: [],
    buyers: [],
  }
  const additionalParams: Record<string, string[] | string> = {}

  searchParams.forEach((value, key) => {
    switch (key) {
      case ESaleRequestFilterParams.CULTURES:
        requestBody.cultures.push(value)
        break

      case ESaleRequestFilterParams.REGION_CODES:
        requestBody.regionCodes.push(Number(value))
        break

      case ESaleRequestFilterParams.STATUSES: {
        const values = value.split(',')
        requestBody.statuses.push(...values)
        break
      }

      case ESaleRequestFilterParams.AGRARIANS:
        requestBody.agrarians.push(value)
        break

      case ESaleRequestFilterParams.BUYERS:
        requestBody.buyers.push(value)
        break

      case ESaleRequestFilterParams.REQUEST_ID:
        requestBody.requestId = value
        break

      default:
        additionalParams[key] = searchParams.getAll(key)
    }
  })

  return { requestBody, additionalParams }
}

export const getSuccessNotificationData = (type: TOrderType) => ({
  title: messages.profile.sales.successOrderNotification[type].title,
  description: messages.profile.sales.successOrderNotification[type].description,
})
